import "./Layout.css";
import { AppShell } from "@mantine/core";
import { Outlet } from "react-router";
import { ErrorBoundary } from "./ErrorBoundary.tsx";

export function Layout() {
	return (
		<AppShell padding="md" className="app-shell-background">
			<div className="app-brand">
				<img src="/images/blink-logo.svg" alt="Blink logo" className="logo" />
				<div className="octagon" />
			</div>
			<main>
				<ErrorBoundary>
					<Outlet />
				</ErrorBoundary>
			</main>
		</AppShell>
	);
}
